(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feeo-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (root) => {
      if (!root || root.dataset.bannerReady === 'true') return;
      root.dataset.bannerReady = 'true';
      const track = root.querySelector('[data-home-banner-track]');
      const slides = Array.from(root.querySelectorAll('[data-home-banner-slide]'));
      if (!track || slides.length < 2) return;
      const dots = Array.from(root.querySelectorAll('[data-home-banner-dot]'));
      const previous = root.querySelector('[data-home-banner-prev]');
      const next = root.querySelector('[data-home-banner-next]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const shouldAutoplay = root.dataset.autoplay === 'true' && !reduceMotion;
      const pauseOnHover = root.dataset.pauseHover === 'true';
      const interval = Math.max(3000, Number(root.dataset.interval) || 5000);
      let active = 0;
      let timer = null;
      let touchStart = null;

      const show = (index, restart = true) => {
        active = (index + slides.length) % slides.length;
        track.style.transform = `translate3d(-${active * 100}%,0,0)`;
        slides.forEach((slide, slideIndex) => slide.setAttribute('aria-hidden', slideIndex === active ? 'false' : 'true'));
        dots.forEach((dot, dotIndex) => {
          dot.classList.toggle('is-active', dotIndex === active);
          if (dotIndex === active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        if (restart) start();
      };
      const stop = () => {
        if (timer) window.clearInterval(timer);
        timer = null;
      };
      const start = () => {
        stop();
        if (shouldAutoplay && !document.hidden) timer = window.setInterval(() => show(active + 1, false), interval);
      };

      previous?.addEventListener('click', () => show(active - 1));
      next?.addEventListener('click', () => show(active + 1));
      dots.forEach((dot, index) => dot.addEventListener('click', () => show(index)));
      if (pauseOnHover) {
        root.addEventListener('mouseenter', stop);
        root.addEventListener('mouseleave', start);
        root.addEventListener('focusin', stop);
        root.addEventListener('focusout', start);
      }
      root.addEventListener('touchstart', (event) => { touchStart = event.touches[0]?.clientX ?? null; }, { passive: true });
      root.addEventListener('touchend', (event) => {
        if (touchStart === null) return;
        const distance = (event.changedTouches[0]?.clientX ?? touchStart) - touchStart;
        if (Math.abs(distance) > 45) show(active + (distance < 0 ? 1 : -1));
        touchStart = null;
      }, { passive: true });
      document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
      slides.forEach((slide, index) => slide.setAttribute('aria-hidden', index === 0 ? 'false' : 'true'));
      start();
    };

    const initialiseAll = (scope = document) => scope.querySelectorAll('[data-home-banner-slider]').forEach(initialise);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialiseAll());
    else initialiseAll();
    document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const slide = event.target.closest?.('[data-home-banner-slide]');
      const root = slide?.closest('[data-home-banner-slider]');
      if (!slide || !root) return;
      const dots = Array.from(root.querySelectorAll('[data-home-banner-dot]'));
      dots[Number(slide.dataset.bannerIndex)]?.click();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feeo-mattes-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initCampaigns = (scope) => {
    const campaigns = [];
    if (scope.matches && scope.matches('[data-mattes-campaign]')) campaigns.push(scope);
    campaigns.push(...scope.querySelectorAll('[data-mattes-campaign]'));

    campaigns.forEach((campaign) => {
      if (campaign.dataset.sliderReady === 'true') return;

      const track = campaign.querySelector('[data-mattes-campaign-track]');
      const slides = Array.from(campaign.querySelectorAll('[data-mattes-campaign-slide]'));
      const dots = Array.from(campaign.querySelectorAll('[data-mattes-campaign-dot]'));
      if (!track || slides.length < 2) return;

      campaign.dataset.sliderReady = 'true';
      let activeIndex = 0;
      let timer;
      let scrollFrame;
      const interval = Math.max(Number(campaign.dataset.interval) || 5000, 3000);
      const autoplay = campaign.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const updateDots = () => {
        dots.forEach((dot, index) => {
          if (index === activeIndex) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };

      const showSlide = (nextIndex) => {
        activeIndex = (nextIndex + slides.length) % slides.length;
        track.scrollTo({ left: slides[activeIndex].offsetLeft, behavior: 'smooth' });
        updateDots();
      };

      const stop = () => {
        if (timer) window.clearInterval(timer);
        timer = undefined;
      };

      const start = () => {
        stop();
        if (autoplay) timer = window.setInterval(() => showSlide(activeIndex + 1), interval);
      };

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          showSlide(Number(dot.dataset.slideTo));
          start();
        });
      });

      track.addEventListener('scroll', () => {
        if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(() => {
          activeIndex = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
          updateDots();
        });
      }, { passive: true });

      campaign.addEventListener('mouseenter', stop);
      campaign.addEventListener('mouseleave', start);
      campaign.addEventListener('focusin', stop);
      campaign.addEventListener('focusout', start);
      campaign.addEventListener('touchstart', stop, { passive: true });
      campaign.addEventListener('touchend', start, { passive: true });
      start();
    });
  };

  initCampaigns(document);
  document.addEventListener('shopify:section:load', (event) => initCampaigns(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
